import { render } from "./UserOrders.vue?vue&type=template&id=578be77c&scoped=true"
import script from "./UserOrders.vue?vue&type=script&lang=js"
export * from "./UserOrders.vue?vue&type=script&lang=js"

import "./UserOrders.vue?vue&type=style&index=0&id=578be77c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578be77c"]])

export default __exports__